import {
  Socket,
  UserCredentials,
  IBaseContact,
  LogsItem,
  SelectMessagesOptions,
} from "../types";
import { Department } from "../../models";
import LS from "../../utils/LocalStorageManager";
import { Phone } from "../../utils/Phone";

interface IRequestChatMessages {
  contact: IBaseContact;
  credentials: UserCredentials;
  customSender: Department;
  options?: SelectMessagesOptions;
}

interface ITypingData {
  user: Partial<UserCredentials>;
  contact: IBaseContact;
  customSender: Department;
}

export default class MessagesHistory {
  // static requestMessagesHistory(io : Socket, contact : IBaseContact) {
  //     io.emit('request-all-history', { contact : contact });
  // }

  static requestMessagesHistoryForContact(
    io: Socket,
    params: IRequestChatMessages
  ) {
    io.emit("request-all-contact-history", params);
  }

  static requestContacts(io: Socket, credentials: UserCredentials) {
    const customSender = LS.getSender();

    if (customSender) {
      customSender.phone = new Phone(customSender.phone).normalized();
    }
    io.emit("request-contacts", {
      credentials: credentials,
      customSender: customSender,
    });
  }

  static sendTypingData(io: Socket, params: ITypingData) {
    io.emit("user-is-typing", params);
  }

  static subscribeContactList(io: Socket, fn: any) {
    io.once("contact-list", fn);
  }

  static subscribeToOutboundMessages(
    io: Socket,
    fn: (info: {
      agent_id: string;
      sender: string; // PHONE_FROM,
      recipient: string; // PHONE_TO,
    }) => void
  ) {
    io.on("msg-sent-by-user", fn);
  }

  // Response with result after sending outbound message
  static subscribeResultOutboundMessages(io: Socket, fn: any) {
    io.on("response-messages", fn);
  }

  static subscribeIncomingMessages(io: Socket, fn: any) {
    io.on("incoming-message", fn);
  }

  static subscribeMessageStatus(io: Socket, fn: any) {
    io.on("message-status", fn);
  }

  static checkWorkspaceAccess(
    io: Socket,
    credentials: UserCredentials,
    fn: any
  ) {
    io.emit("check-workspace-access", credentials);
    io.once("workspace-access-data", fn);
  }

  static writeLogsMessage(io: Socket, params: LogsItem) {
    io.emit("write-logs", params);
  }

  static subscribeTypingData(io: Socket, fn: any) {
    io.on("somebody-typing", fn);
  }
}
